<template>
  <div>
    <b-modal ref="modal" title="Alterar senha" header-class="border-bottom-0">
      <div class="container-fluid">
        <!-- form  -->
        <div class="row">
          <div class="card w-100">
            <div class="card-body">
              <div class="col-md-12">
                <div class="d-flex">
                  <div class="mr-3">
                    <avatar inline color="#fff" :size="40" :username="user.name" :initials="getInitial(user.name)"></avatar>
                  </div>
                  <div>
                    {{user.name}}
                    <br />
                    <small class="text-muted">{{ user.email}}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br />

      <div class="row">
        <div class="col-md-12">
          <password-input 
            v-model="form.oldPassword.value"
            :name="'oldPassword'"
            :form="form"
            :alias="form.oldPassword.alias" 
            placeholder="senha atual" />
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <password-input 
            v-model="form.newPassword.value"
            :name="'newPassword'"
            :form="form"
            :alias="form.newPassword.alias" 
            placeholder="digite uma senha" />
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <password-input 
            v-model="form.newPassword_confirmation.value"
            :name="'newPassword_confirmation'"
            :form="form"
            :alias="form.newPassword_confirmation.alias" 
            placeholder="digite novamente" />
        </div>
      </div>

      <error-handler :error="error" />

      <!-- form  -->

      <div slot="modal-footer">
        <button role="button" class="btn btn-outline-secondary" @click="$refs.modal.hide()">
          <i class="fas fa-times"></i> Cancelar
        </button>
        <button role="button" class="btn btn-success" style="margin-left:5px" @click="store">
          <i class="fas fa-check"></i> Alterar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Avatar from "vue-avatar";
import Filters from "./../../mixins/Filters.js";
import Form from "./../../mixins/Form.js";

export default {
  components: { Avatar },

  data: function() {
    return {
     
     form: new Form({
        oldPassword: {
          validate : {
            required : true
          },
          alias : 'Senha atual'
        },

        newPassword: {
          validate : {
            required : true
          },
          alias : 'Nova Senha'
        },

        newPassword_confirmation: {
          validate : {
            required : true
          },
          alias : 'Confirme sua senha'
        }
      }),

      error: null
    };
  },

  computed: {
    user() {
      return this.$store.state.user;
    }
  },

  methods: {
    
    open() {
      this.form.reset()
      this.$refs.modal.show();
    },

    getInitial(value) {
      return value.slice(0, 1);
    },

    store() {
      this.error = null

      if (this.form.isValid()) {
        this.$store.commit('showLoading');
        axios
          .post(process.env.BASE_URL + 'api/user/updatepassword', this.form.getValues())
          .then(response => {
            
            this.$store.commit('hideLoading');
            this.$refs.modal.hide();
            this.$emit('stored');

          })
          .catch(error => {

            this.$store.commit('hideLoading');
            this.error = error;

          });
      } 
    },
  }
};
</script>

<style>
</style>